//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
function set_date_url() {
  let origin = `${window.location.origin}${window.location.pathname}`;
  let url = new URL(origin);
  let date_get = typeof $_GET['cal_date'] !== 'undefined' && $_GET['cal_date'] !== 'undefined' ? $_GET['cal_date'] : false;
  let date = $('.current_date').data('date');
  url.searchParams.append('cal_date', date_get ? date_get : date);
  history.pushState({}, null, url);
}
// function clear_reload_date_url(){
//   let origin = `${window.location.origin}${window.location.pathname}`;
//   let url = new URL(origin);
//   // let date = $('.current_date').data('date');
//   // url.searchParams.append('cal_date', date);
//   // url.searchParams.append('cal_date', null);
//   history.pushState({}, null, url);
// }

let $_GET = {};
function refresh_get() {
  $_GET = {};
  if (document.location.toString().indexOf('?') !== -1) {
    let query = document.location
      .toString()
      // get the query string
      .replace(/^.*?\?/, '')
      // and remove any existing hash string (thanks, @vrijdenker)
      .replace(/#.*$/, '')
      .split('&');

    for (let i = 0, l = query.length; i < l; i++) {
      let aux = decodeURIComponent(query[i]).split('=');
      $_GET[aux[0]] = aux[1];
    }
  }
}
refresh_get()

export default {
  name: 'Calendar',
  components: {
    FullCalendar,
  },
  props: {
    expert: String,
    ajax: String,
    handleDateSelect: Function,
  },
  data: function () {
    const self = this;
    return {
      loading: false,
      calendarOptions: {
        height: 'auto',
        locale: 'nl',
        firstDay: 1,
        selectable: false,
        fixedWeekCount: true,
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        datesSet: function () {
          // let date = typeof $_GET['cal_date'] !== 'undefined' && $_GET['cal_date'] !== 'undefined' ? $_GET['cal_date'] : false;
          // if (date) {
          //   setTimeout(() => {
          //     let el = $('[data-date=' + date + ']');
          //     el.addClass('current_date');
          //     self.handleDateSelect(date);
          //   }, 50);
          // }
        },
        eventContent: function (event) {
          const italicEl = document.createElement('i');
          italicEl.innerHTML = `<div class="fc-daygrid-event-dot" style="border-color: ${event.borderColor};"></div>`;
          const arrayOfDomNodes = [
            italicEl,
          ];
          return {
            domNodes: arrayOfDomNodes,
          };
        },
        dateClick: function (info) {
          $('td.current_date').removeClass('current_date')
          $('td').find(`[data-date='${info.dateStr}']`).addClass('current_date');
          set_date_url();
          self.handleDateSelect(info.dateStr);
        },
        loading: function (isLoading) {
          let that = this;

          refresh_get();
          let reload_date = typeof $_GET['reload_date'] !== 'undefined' && $_GET['reload_date'] !== 'undefined' ? $_GET['reload_date'] : false;

          if (!isLoading && reload_date === '1') { // done loadin
            refresh_get();
            // eslint-disable-next-line no-unused-vars
            let reload_date = typeof $_GET['reload_date'] !== 'undefined' && $_GET['reload_date'] !== 'undefined' ? $_GET['reload_date'] : false;
            let date = typeof $_GET['cal_date'] !== 'undefined' && $_GET['cal_date'] !== 'undefined' ? $_GET['cal_date'] : false;
            set_date_url();
            if (date) {
              // console.log(that);
              let el = $('[data-date=' + date + ']');
              el.addClass('current_date');
              that.gotoDate(date);
            }
          }
        },
        eventSources: [
          {
            url: `${self.ajax}?action=agendas&expert=${self.expert}`,
          },
        ],
      },
    };
  },
  methods: {
    reload: function () {
      this.loading = true;
      this.$nextTick().then(() => {
        this.loading = false;
      });
    },
  },
  mounted: function () {
    let date = typeof $_GET['cal_date'] !== 'undefined' && $_GET['cal_date'] !== 'undefined' ? $_GET['cal_date'] : false;
    if (date) {
      this.$refs['FullCalendar'].$options.calendar.gotoDate(date);
      let el = $('[data-date=' + date + ']');
      el.addClass('current_date');
      this.handleDateSelect(date);
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/Agenda/Calendar.vue